export default __webpack_public_path__ + "static/media/knight_white.145b8796.svg";